import { doc, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../lib/firebase";

export const getPaymentSettings = async () => {
  try {
    const docRef = doc(db, "settings", "payment");
    const snap = await getDoc(docRef);
    if (snap.exists()) {
      return snap.data();
    }
    return null;
  } catch (error) {
    console.error("Error fetching payment settings:", error);
    return null;
  }
};

export const uploadPaymentScreenshot = async (orderId, file) => {
  const storageRef = ref(storage, `payments/${orderId}/${file.name}`);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
};

export const uploadEventPaymentScreenshot = async (registrationId, file) => {
  const storageRef = ref(storage, `event_payments/${registrationId}_${Date.now()}_${file.name}`);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
};
